import { User } from '../../model/user/User';
import {AuthActionTypes} from '../actions/auth.actions';
import {INIT, UPDATE} from '@ngrx/store';


export interface State {
  // is a user authenticated?
  isAuthenticated: boolean;
  // if authenticated, there should be a user object
  user: User | null;
  // error message
  errorMessage: Error | null;
}

export const initialState: State = {
  isAuthenticated: false,
  user: null,
  errorMessage: null,
};

export function authReducer(state = initialState, action) {
  switch (action.type) {
    case AuthActionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        user:
          {
            email: action.payload.email,
            name: action.payload.name,
            surname: action.payload.surname,
            ssn: action.payload.ssn,
            phoneNumber: action.payload.phoneNumber,
            role: action.payload.role,
            birthDate: action.payload.birthDate,
            birthPlace: action.payload.birthPlace,
            notifications: action.payload.notifications
          },
        errorMessage: null
      };
    }
    case AuthActionTypes.LOGIN_FAILURE: {
      return {
        ...state,
        isAuthenticated: true,
        user: null,
        errorMessage: 'Email e/o password non corretta'
      };
    }

    case AuthActionTypes.LOGOUT: {
      return initialState;
    }

    case INIT: {
      console.log('Auth reducer INIT ' + action.type);
      try {
        const data = localStorage.getItem('user');
        if (data) {
          return {
            ...state,
            user: JSON.parse(data),
            isAuthenticated: true,
            errorMessage: null
          };
        } else {
          return {
            ...state,
          };
        }
      } catch (error) {
        return null;
      }
    }

    case UPDATE: {
      console.log('Auth reducer UPDATE ' + action.type);
      try {
        const data = localStorage.getItem('user');
        if (data) {
          return {
            ...state,
            user: JSON.parse(data),
            isAuthenticated: true,
            errorMessage: null
          };
        } else {
          return {
            ...state,
          };
        }
      } catch (error) {
        return null;
      }
    }

    default: {
      const data = localStorage.getItem('user');
      if (data) {
        return {
          ...state,
          user: JSON.parse(data),
          isAuthenticated: true,
          errorMessage: null
        };
      } else {
        return state;
      }
    }
  }
}

